export default {"src":"/_next/static/media/green-native-token.36b7b298.svg","height":122,"width":122};